import TimeLine from '../../Base/Components/TimeLine/TimeLine';
import DespachosEspecialesScreen from '../../Screen/Planeacion/DespachosEspeciales/DespachosEspecialesScreen'
import AutorizacionUsoHilazaScreen from '../../Screen/Planeacion/Hilaza/AutorizacionUsoHilazaScreen'
import WIPScreen from '../../Screen/Planeacion/WIP/WIPScreen'

export const PlanningRoutes = [
  {
    path: 'Planning/DespachosEspeciales',
    permiso: 66,
    element: <DespachosEspecialesScreen />,
  },
  {
    path: 'Planning/AutorizacionHilaza',
    permiso: 66,
    element: <AutorizacionUsoHilazaScreen />,
  },
  {
    path: 'Planning/WIP',
    permiso: 109,
    element: <WIPScreen />,
  },
  {
    path: 'Planning/WIP/Timeline',
    permiso: 134,
    element: <TimeLine />,
  },
]

export default PlanningRoutes;
